import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon width="120" height="120" viewBox="0 0 120 120" {...props}>
      <title>{props.title || 'Best Rated'}</title>
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.4874 17.8469C35.4874 17.8469 63.0672 9.10655 93.6777 23.186C124.288 37.2654 94.9766 82.4628 94.9766 82.4628C94.9766 82.4628 69.5964 132.359 36.7317 97.1165C3.86698 61.8736 -15.753 30.2808 35.4874 17.8469"
          fill="#6E19B7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M92.8564 29.4315C92.8564 29.4315 108.394 51.7663 104.338 83.1549C100.283 114.543 51.6067 100.771 51.6067 100.771C51.6067 100.771 -0.179293 91.8329 22.2023 52.5473C44.584 13.2617 67.398 -13.1201 92.8564 29.4315"
          fill="#556BDC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M103.002 46.7626C103.002 46.7626 106.906 75.3135 87.7162 102.971C68.5264 130.629 28.8585 94.1989 28.8585 94.1989C28.8585 94.1989 -16.1335 60.8313 24.378 34.5481C64.8895 8.26501 99.5132 -5.63719 103.002 46.7626"
          fill="#3DC6B6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M91.9805 36C93.6265 36 94.9609 34.6569 94.9609 33C94.9609 31.3431 93.6265 30 91.9805 30C90.3344 30 89 31.3431 89 33C89 34.6569 90.3344 36 91.9805 36Z"
          fill="#556BDC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.9805 112C34.6265 112 35.9609 110.657 35.9609 109C35.9609 107.343 34.6265 106 32.9805 106C31.3344 106 30 107.343 30 109C30 110.657 31.3344 112 32.9805 112Z"
          fill="#3DC6B6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9805 70C21.6265 70 22.9609 68.6569 22.9609 67C22.9609 65.3431 21.6265 64 19.9805 64C18.3344 64 17 65.3431 17 67C17 68.6569 18.3344 70 19.9805 70Z"
          fill="#6E19B7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M57 19C58.1046 19 59 18.1046 59 17C59 15.8954 58.1046 15 57 15C55.8954 15 55 15.8954 55 17C55 18.1046 55.8954 19 57 19Z"
          fill="#6E19B7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M86.987 82C88.0844 82 88.974 81.1046 88.974 80C88.974 78.8954 88.0844 78 86.987 78C85.8896 78 85 78.8954 85 80C85 81.1046 85.8896 82 86.987 82Z"
          fill="#556BDC"
        />
        <path
          d="M72.4137 65.9248L71.7063 66.6482L71.8701 67.6467L74.4816 83.5731L60.9642 76.1225L59.9987 75.5904L59.0332 76.1226L45.5158 83.5744L48.1298 67.647L48.294 66.6466L47.5842 65.9228L36.443 54.5609L51.7395 52.229L52.7928 52.0684L53.2471 51.1047L59.9989 36.7847L66.753 51.105L67.2074 52.0684L68.2605 52.229L83.5298 54.5567L72.4137 65.9248Z"
          fill="white"
          stroke="white"
          strokeWidth="4"
        />
      </g>
    </Icon>
  )
}
